"use client";

import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import dynamic from "next/dynamic";
import { Swiper as SwiperBase, SwiperSlide } from "swiper/react";
import { Grid, Pagination, Scrollbar, Navigation } from "swiper/modules";
const Card = dynamic(() => import("@/components/common/card/ProductsCard"));

const LandingPageSwiper = ({
  layout,
  products,
  bestSellerImg,
  recommendedImg,
  config = {},
}) => {
  const modulesMap = {
    Grid,
    Pagination,
    Scrollbar,
    Navigation,
  };

  const modules = (config.modules || []).map((name) => modulesMap[name]);
  return (
    <SwiperBase
      {...config}
      modules={modules}
      className={`customProductSlider deals-product-slider ${layout}-slider`}
    >
      {products.map((product, index) => (
        <SwiperSlide key={product?.id || index}>
          <Card
            product={product}
            isCarParts={false}
            loop_index={index}
            item_list="Featured Products"
            bestSellerImg={bestSellerImg}
            recommendedImg={recommendedImg}
          />
        </SwiperSlide>
      ))}
    </SwiperBase>
  );
};

export default LandingPageSwiper;
